import { useFormikContext } from "formik";
import { UpdateEligibilityFormValues } from "../types";
import { useUpdateEligibilityDialogContext } from "../context";

export const useUpdateEligibilityActions = () => {
  const { closeDialog } = useUpdateEligibilityDialogContext();
  const { submitForm, isSubmitting, validateForm, setSubmitting } =
    useFormikContext<UpdateEligibilityFormValues>();

  const handleSubmit = async () => {
    const validationErrors = await validateForm();
    const isValid = Object.keys(validationErrors).length === 0;
    if (!isValid) {
      return false;
    }
    setSubmitting(true);
    setTimeout(() => {
      submitForm();
    }, 2000); // Simulate a delay for demonstration purposes
    return true;
  };

  return {
    handleSubmit,
    closeDialog,
    isSubmitting,
  };
};
